<template>
  <div class="tooltip-daterange">
    <div class="tooltip-daterange-preview">
      <div ref="dateRangeBox" class="tooltip-daterange-preview-selection" @click="show = !show">
        {{ $t('tooltipDateRange.prefix') }}
        <span class="tooltip-daterange-preview-type">{{ selected.presentation }}</span>
        <span class="relative">
          <VSvgIcon
            name="menu-down"
            class="transition duration-200 ease-in"
            :class="[show ? 'transform rotate-180' : 'transform rotate-0']"
          />
          <TooltipPopup v-if="show" classes="ml-1/2 transform -translate-x-1/2 text-black">
            <template>
              <ul class="tooltip-daterange-popup-list">
                <li
                  v-for="(range, index) in $options.ranges"
                  :key="`range-${index}`"
                  class="tooltip-daterange-popup-item"
                  :class="[range.value === selected.value && 'bg-orange-100']"
                  @click="handleSelect(range)"
                >
                  {{ range.presentation }}
                </li>
              </ul>
            </template>
          </TooltipPopup>
        </span>
      </div>

      <!-- show datepickers when range is 'custom date range'  -->
      <div class="tooltip-daterange-datepicker" v-if="showDatePicker">
        <DatePicker
          v-model="range"
          mode="range"
          nav-visibility="hidden"
          :columns="$screens({ sm: 2 }, 1)"
          :popover="{ placement: 'bottom', visibility: 'click' }"
        >
          <div class="tooltip-daterange-datepicker-container">
            <div class="tooltip-daterange-datepicker-section">
              <VSvgIcon name="calendar" class="tooltip-daterange-datepicker-icon" />
              <div class="tooltip-daterange-datepicker-date">
                {{ formatDate(range.start) }}
              </div>
              <VSvgIcon name="menu-down" />
            </div>

            <VSvgIcon name="arrow-right" class="ml-1 mr-2 tooltip-daterange-datepicker-icon" />

            <div class="tooltip-daterange-datepicker-section">
              <VSvgIcon name="calendar" class="tooltip-daterange-datepicker-icon" />
              <div class="tooltip-daterange-datepicker-date">
                {{ formatDate(range.end) }}
              </div>
              <VSvgIcon name="menu-down" />
            </div>
          </div>
        </DatePicker>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';

import DatePicker from 'v-calendar/lib/components/date-picker.umd';

import VSvgIcon from '@/components/base/VSvgIcon';
import TooltipPopup from './TooltipPopup';

import { formatTooltipDateRange, DATE_RANGES } from '@/utils';

export default {
  name: 'TooltipDateRange',
  components: { VSvgIcon, DatePicker, TooltipPopup },
  props: {
    tooltipData: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      selected: {},
      show: false,
      range: {
        start: new Date(),
        end: new Date(),
      },
      dropdownPosition: [],
    };
  },
  ranges: [],
  computed: {
    showDatePicker() {
      return this.selected.value === 'custom';
    },
    disabledDates() {
      return {
        to: this.startDate,
      };
    },
  },
  watch: {
    range({ start, end }) {
      const datesRange = formatTooltipDateRange('custom', start, end);
      this.$emit('onSelect', datesRange);
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'MM/dd/yyyy');
    },
    handleSelect(rangeType) {
      this.selected = rangeType;
      const datesRange = formatTooltipDateRange(
        rangeType.value,
        this.range.startDate,
        this.range.endDate,
      );
      this.$emit('onSelect', datesRange);
    },
    handleClickOutside(e) {
      const element = this.$refs.dateRangeBox;
      if (!(element === e.target || element.contains(e.target))) {
        this.show && (this.show = false);
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  created() {
    this.$options.ranges =
      this.tooltipData ??
      DATE_RANGES.map(range => ({
        ...range,
        presentation: this.$t(`tooltipDateRange.range.${range.value}`),
      }));
    this.selected = this.$options.ranges[0];
  },
};
</script>
